import { ToolSelectionPanel } from 'components/minute/controls/ToolSelectionPanel';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ControlLayout = (props: Props): JSX.Element => {
    return (
        <S_ControlLayout className={props.className}>
            <ToolSelectionPanel />
        </S_ControlLayout>
    );
};

const S_ControlLayout = styled.div`
    position: absolute;
    bottom: 0;
    z-index: 1;
    display: flex;
    justify-content: center;
    width: 80%;
    left: 10%;
    bottom: -90px;
`;
